import React from 'react';

/**
 * A loading spinner component to show during authentication checks
 */
const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-gray-50">
      <div className="h-16 w-16 animate-spin rounded-full border-4 border-t-4 border-gray-200 border-t-blue-600"></div>
      <p className="mt-4 text-lg text-gray-700">{message}</p>
    </div>
  );
};

export default LoadingSpinner;